import { useContext, useEffect, useState, ComponentProps } from 'react';
import { connect } from 'react-redux';
import { useUnmountPromise } from 'react-use';

import * as actions from '../../../vehicles/store/actions';
import { FormContext, SelectInput } from '../forms';

/** Минимальный структурный тип элемента справочника модификаций (готового интерфейса в vehicles/api нет). */
interface VehicleModificationItem {
  id: string | number,
  name?: string,
}

type VehicleModificationSelectorProps = Omit<ComponentProps<typeof SelectInput>,
  'value' | 'defaultValue' | 'onChange'> &{
  generationId?: string | number,
  disabled?: boolean,
  onChange?: (event: any) => void,
  /** из mapStateToProps */
  modifications?: VehicleModificationItem[],
  /** из mapDispatchToProps */
  getVehicleModifications: (generationId?: string | number) => Promise<unknown>,
};

const VehicleModificationSelector = (props: VehicleModificationSelectorProps) => {
  const mounted = useUnmountPromise();
  // FormContext создаётся в utils.js без дженерика — приводим к нужной форме (см. SelectInput.tsx)
  const { handleChange } = useContext(FormContext) as { handleChange?: (event: any) => void };
  const {
    disabled,
    generationId,
    modifications,
    getVehicleModifications,
    onChange,
    name = 'modificationId',
    ...rest
  } = props;

  const [loading, setLoading] = useState(false);

  const loadData = (): Promise<unknown> => {
    if (generationId) {
      setLoading(true);

      return getVehicleModifications(generationId).finally(() => setLoading(false));
    }

    return Promise.resolve();
  };

  useEffect(() => {
    mounted(loadData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [generationId]);

  return (
    <SelectInput
      { ...rest }
      name={ name }
      data={ modifications }
      dataTitle='name'
      dataValue='id'
      loading={ loading }
      disabled={ disabled || loading }
      onChange={ (event) => { handleChange(event);if (typeof onChange === 'function') onChange(event); } }
      sort
    />
  );
};

const mapStateToProps = (state) => {
  return {
    modifications: state.vehicles?.modifications,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getVehicleModifications: payload => dispatch(actions.getVehicleModifications(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VehicleModificationSelector);
